export default __webpack_public_path__ + "static/media/34t.aca9baf7.jpg";